import { Display } from '@/components/Display/Display';
import MobileResult from './MobileResult';
import WebResult from './WebResult';
import { getEnvironment } from '@/utils/Mobile';
const env = getEnvironment();
const ResourceResult = (props) => {
    return (
        <>
            <Display show={env === 'h5'}>
                <MobileResult {...props}></MobileResult>
            </Display>
            <Display show={env === 'pc'}>
                <WebResult {...props}></WebResult>
            </Display>
        </>
    );
};

export default ResourceResult;
